<ng-container *ishBrowserLazyView>
  @if (recentlyProducts$ | async; as products) { @if (products.length) {
  <div class="product-list-container" data-testing-id="recently-viewed">
    <h2>{{ 'recentlyViewed.component.heading' | translate }}</h2>
    <ish-skip-content-link skipToElementId="pdp-view-all-link" />
    @if (products.length < 5) {
    <div class="product-list row">
      <!-- modified the below line for icsa customization -->
      <!--
            <div class="product-list row">
              -->
      @for (productSku of products; track productSku) {
      <div class="col-6 col-lg-3 product-list-item">
        <ish-product-item ishProductContext [sku]="productSku" displayType="tile" />
      </div>
      }
    </div>
    } @else {
    <ish-products-list [productSKUs]="products" [listStyle]="'carousel'" [listItemStyle]="'tile'" [slideItems]="4" />
    }
    <a
      id="pdp-view-all-link"
      [routerLink]="['/recently']"
      class="view-all"
      data-testing-id="view-all"
      [attr.aria-label]="'common.view_all.link.label' | translate"
      >{{ 'common.view_all.link' | translate }}</a
    >
  </div>
  } }
</ng-container>
